module.exports = __webpack_public_path__ + "static/media/facebook_grey_big.edd474db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/facebook_grey_big.png
// module id = ./src/assets/media/facebook_grey_big.png
// module chunks = 16